import { AuthContextType, AuthStateProps } from "./types";

export const defaultValues: AuthContextType = {
  authState: {
    accessToken: undefined,
  },
  updateState: (_newState: Partial<AuthStateProps>) => null,
  persistToken: (_token: string) => null,
  logout: () => null
};
